import React from 'react';
import { Typography } from '@mui/material';

const CollapsibleText = ({ text, expanded, maxLength = 200 }) => {
  if (text == null) return null; // Handle null or undefined text gracefully

  const safeText = String(text); // Ensure text is treated as a string

  // Determine displayed text based on expansion state
  const isLongText = safeText.length > maxLength;
  const displayText = expanded ? safeText : `${safeText.substring(0, maxLength)}${isLongText ? '...' : ''}`;

  return (
    <Typography
      variant="body2"
      sx={{
        maxHeight: expanded ? 'none' : '100px', // Expand fully or limit height
        overflowY: expanded ? 'visible' : 'auto', // Enable scroll only when collapsed
        padding: '8px',
        border: '1px solid #ddd',
        borderRadius: '4px',
        background: '#f9f9f9',
        whiteSpace: 'pre-wrap', // Preserve line breaks
        wordBreak: 'break-word', // Prevent overflow
      }}
    >
      {displayText}
    </Typography>
  );
};

export default CollapsibleText;